if(typeof BSS_B2B != undefined) {
    if(window.location.pathname.includes("/products")) {
        setTimeout(() =>{
            let addToCartBtn = $(".product-form__buttons .product-form__submit");
            if(addToCartBtn.length) {
                addToCartBtn.on("click", () =>{
                    setTimeout(() =>{
                        BSS_B2B.cart.fixer(JSON.parse(document.getElementById("bss-b2b-store-data").innerHTML),false,false);
                    }, 1000)
                })
            }
        }, 300)
        
        setTimeout(() =>{
            function handleButtonClick(e) {
              e.preventDefault();
              const $button = $(this);
              let oldText = $(this).text();
              $button.css({'pointer-events': 'none', 'opacity': '0.6'});
              $button.text("Loading ...");
              setTimeout(() =>{
                $button.css({'pointer-events': 'unset', 'opacity': '1'})
                  $button.text(oldText);
              }, 2000);
            }
           
           $(document).on('click dblclick', '.cart-notification__links button[name="checkout"]', handleButtonClick);
        }, 500)
    }
}